import store from 'src/storeWire';
import { isNumber } from 'underscore';

export default class allTabsCountResponseMaker {
    data = [];
    data_to_send = allTabsCountResponseMaker.defaultData();

    constructor(data) {
        this.data = data;
    }

    static defaultData = () => {
        return {
            allTabsCount: {
                npiCount: 0,
                productCount: 0,
                productListingCount: 0,
                videoCount: 0,
                contentCount: 0,
                documentCount: 0,
                moreCount: 0,
                allCount: 0,
            }
        };
    }
    process = async () => {
        // Prepare Tabs Count
        let tabResp = allTabsCountResponseMaker.defaultData().allTabsCount;

        if (this.data.data.npiCount && isNumber(this.data.data.npiCount) && this.data.data.npiCount > 0) {
            tabResp['npiCount'] = this.data.data.npiCount
        } else {
            let s = store.getState();
            let allCnt = s?.entities?.model_HomePageContent?.allTabsCount;
            tabResp['npiCount'] = allCnt ? allCnt.npiCount : 0;
        }

        if (this.data.data.productCount !== undefined && this.data.data.productCount !== null && isNumber(this.data.data.productCount)) {
            tabResp['productCount'] = this.data.data.productCount
        }
        //Wrong Data Fetched so disabling it.
        /*if (this.data.data.videoCount !== undefined && this.data.data.videoCount !== null && isNumber(this.data.data.videoCount)) {
            tabResp['videoCount'] = this.data.data.videoCount
        }*/
        if (this.data.data.contentCount !== undefined && this.data.data.contentCount !== null && isNumber(this.data.data.contentCount)) {
            tabResp['contentCount'] = this.data.data.contentCount
        }
        if (this.data.data.productListingCount !== undefined && this.data.data.productListingCount !== null && isNumber(this.data.data.productListingCount)) {
            tabResp['productListingCount'] = this.data.data.productListingCount
        }
        if (this.data.data.docCount !== undefined && this.data.data.docCount !== null && isNumber(this.data.data.docCount)) {
            tabResp['documentCount'] = this.data.data.docCount
        }
        if (this.data.data.moreCount !== undefined && this.data.data.moreCount !== null && isNumber(this.data.data.moreCount)) {
            tabResp['moreCount'] = this.data.data.docCount
        }
        
        tabResp.contentTabCount = this.data.data.contentTabCount;
        tabResp['allCount'] =
            tabResp['npiCount'] +
            tabResp['productCount'] +
            tabResp['productListingCount'] +
            tabResp['videoCount'] +
            tabResp['contentCount'] +
            tabResp['documentCount'] +
            tabResp['moreCount'];
        this.data_to_send.allTabsCount = tabResp;
        return this;
    };

    run = () => {
        return this;
    };

    get = () => {
        return {
            data: this.data_to_send
        };
    };
}